import React from 'react'

export default function Footer() {
  return (
    <div className="footer-section">
      <footer className="footer">© 2024 Abundance Esim</footer>
    </div>
  );
}
